import { Directive, HostListener, Input } from '@angular/core';
import { HotjarService } from 'src/app/core';

@Directive({
  selector: '[appHotjarEvent]',
})
export class HotjarEventDirective {
  @Input() appHotjarEvent: string;

  constructor(private hotjarService: HotjarService) {}

  @HostListener('click') onClick() {
    this.hotjarService.event(this.appHotjarEvent);
  }
}
